import { render } from "./FileSelectForm.vue?vue&type=template&id=5af1ddc6&scoped=true"
import script from "./FileSelectForm.vue?vue&type=script&lang=js"
export * from "./FileSelectForm.vue?vue&type=script&lang=js"

import "./FileSelectForm.vue?vue&type=style&index=0&id=5af1ddc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5af1ddc6"

export default script